export const nameRegex: RegExp = /^[a-z ,.'-]+$/i;
export const passwordRegex: RegExp = /(?=.*\d)(?=.*\W+)(?!.*[.\n\s])(?=.*[A-Z])(?=.*[a-z])(?=.{8,}).*$/;
export const emailRegex: string =
  '^(([^<>()[\\]\\\\.,;:\\s@"]+(\\.[^<>()[\\]\\\\.,;:\\s@"]+)*)|.(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$';
export const noSpacesRegex: RegExp = /^\S*$/;

export const EMAIL_LIST_REGEX =
  /^(?:\s*[\w.+-]+@[a-zA-Z\d-]+\.[a-zA-Z\d.-]+\s*,)*\s*[\w.+-]+@[a-zA-Z\d-]+\.[a-zA-Z\d.-]+\s*$/;
